import { Component } from '@angular/core';

@Component({
  template:
    '<div class="wide-grid"><generic-grid [metadataName]="loginStats"></generic-grid></div>',
})
export class LoginStatsComponent {
  public loginStats: string = 'PortalLoginStats';
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-grids/login-stats.component.ts